import axios from 'axios';

axios.defaults.withCredentials = true;

export async function login(email, password) {
    try {
      const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}login`, { email, password });
      // El token se guarda en las cookies
      return response?.data?.message;

    } catch (error) {
      console.error('Error de inicio de sesión', error);
      return error?.response?.data?.message || 'Error de inicio de sesión';
    }
  }